module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 scrollable",
    attrs: {
      "id": "chatbox"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._l((_vm.messageStore.messages), function(message) {
    return _c('div', {
      key: message.id,
      staticClass: "message-item",
      class: {
        'user-message': message.isUser,
        'ai-message': !message.isUser && !message.isSystem,
        'system-message': message.isSystem
      }
    }, [(!message.isSystem) ? _c('div', {
      staticClass: "message-avatar"
    }, [_c('i', {
      class: message.isUser ? 'bi bi-person-circle' : 'bi bi-robot'
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "message-content"
    }, [(!message.isSystem) ? _c('div', {
      staticClass: "message-header"
    }, [_c('span', {
      staticClass: "message-sender"
    }, [_vm._v(_vm._s(message.isUser ? 'You' : 'Joule'))]), _vm._v(" "), _c('small', {
      staticClass: "message-time text-muted"
    }, [_vm._v(_vm._s(_vm.formatTime(message.timestamp)))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "callout call-success message-text"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatMessage(message.sanitizedText || message.text))
      }
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "callout call-info",
    staticStyle: {
      "margin": "8px 0"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('strong', [_vm._v("Working Files")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-xs",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isUploadingWorkingFiles,
      "title": "Upload file"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openWorkingFilePicker()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('input', {
    ref: "workingFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": ".csv,.json,.txt,.xlsx"
    },
    on: {
      "change": _vm.onWorkingFilesSelected
    }
  }), _vm._v(" "), (_vm.isLoadingWorkingFiles) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Loading...")]) : (_vm.isUploadingWorkingFiles) ? _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("Uploading...")]) : _vm._e(), _vm._v(" "), (_vm.workingFiles.length > 0) ? _c('ul', {
    staticStyle: {
      "margin": "6px 0 0 16px"
    }
  }, _vm._l((_vm.workingFiles), function(file) {
    return _c('li', {
      key: file
    }, [_c('a', {
      staticClass: "working-file-link",
      attrs: {
        "href": _vm.getWorkingFileUrl(file),
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v("\n                                                " + _vm._s(file) + "\n                                            ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-link btn-xs text-danger",
      staticStyle: {
        "padding": "0 0 0 6px"
      },
      attrs: {
        "type": "button",
        "disabled": _vm.isDeletingWorkingFile(file),
        "title": "Delete file"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deleteWorkingFile(file)
        }
      }
    }, [_vm._v("\n                                                x\n                                            ")])])
  }), 0) : _c('div', {
    staticClass: "text-muted",
    staticStyle: {
      "margin-top": "6px"
    }
  }, [_vm._v("No working files.")])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "questionInput"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "input-group chat-content"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.question),
      expression: "question"
    }],
    staticClass: "form-control",
    staticStyle: {
      "min-width": "100%"
    },
    attrs: {
      "disabled": _vm.waitingForResponse,
      "rows": "4",
      "cols": "120",
      "placeholder": "Enter your question followed by Enter"
    },
    domProps: {
      "value": (_vm.question)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onQuestionEnterPress($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.question = $event.target.value
      }
    }
  }, [_vm._v("                                        <!--<span class=\"input-group-btn\">\n                                        <button class=\"btn btn-default form-control\"\n                                                style=\"font-size:12px\"\n                                                @click=\"sendQuestionStream\" type=\"button\">\n\n                                            <span><i class=\"fa fa-paper-plane\" style=\"transform: rotate(0.15turn);\"></i></span>\n                                        </button>\n                                    </span>-->\n")])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox",
    staticStyle: {
      "margin": "6px 0 10px 0"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "12px",
      "font-weight": "normal"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeThinking),
      expression: "includeThinking"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.waitingForResponse
    },
    domProps: {
      "checked": Array.isArray(_vm.includeThinking) ? _vm._i(_vm.includeThinking, null) > -1 : (_vm.includeThinking)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeThinking,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeThinking = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeThinking = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeThinking = $$c
        }
      }
    }
  }), _vm._v("\n                                        Show thinking\n                                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-sm",
    staticStyle: {
      "background-color": "transparent"
    },
    attrs: {
      "disabled": ""
    }
  }, [(_vm.waitingForResponse) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _vm._e(), _vm._v(" "), (_vm.waitingForResponse && _vm.currentProgressMessage) ? _c('span', {
    staticClass: "progress-status-text"
  }, [_vm._v("\n                                    " + _vm._s(_vm.currentProgressMessage) + "\n                                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-left"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    on: {
      "click": _vm.clearChat
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 ai-context-info"
  }, [(_vm.modelId) ? _c('em', {
    staticClass: "small "
  }, [_vm._v(" Current Model: " + _vm._s(_vm.modelId) + " ")]) : _c('em', [_c('em', {
    staticClass: "small"
  }, [_vm._v(" Current Model: (none)")])]), _vm._v(" "), (_vm.modelId) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.currentNodePath) ? _c('em', {
    staticClass: "small"
  }, [_vm._v(" Path: " + _vm._s(_vm.currentNodePath) + " ")]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header"
  }, [_c('div', {
    staticClass: "box-title",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_c('h5', [_vm._v("\n                                ArrowHead AI Assistant\n                            ")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-42db7dcc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42db7dcc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/ai-assistant/ai-assistant.vue.html
// module id = 1099
// module chunks = 0